class APIS {
    apis() {
        return {
            fetch: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/blacklist/tokens',
            },
            add: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/blacklist/token/add',
            },
            delete: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/blacklist/token/delete',
            },
        };
    }
}

export default new APIS();
